const collapsibleHeading = document.querySelector('.collapsible-heading h1');
const collapsibleContent = document.querySelector('.collapsible-content');

function toggleCollapsible() {
    collapsibleHeading.classList.toggle('open');
    collapsibleContent.classList.toggle('collapsed');
}

function handleResize() {
    if (collapsibleHeading && collapsibleContent) {
        if (window.innerWidth < 768) {
            collapsibleHeading.addEventListener('click', toggleCollapsible);
			collapsibleContent.classList.add('collapsed');
        } else {
            collapsibleHeading.removeEventListener('click', toggleCollapsible);
			collapsibleContent.classList.remove('collapsed');
        }
    }
}

if (collapsibleHeading && collapsibleContent) {
    if (window.innerWidth < 768) {
        collapsibleHeading.addEventListener('click', toggleCollapsible);
    } else {
		collapsibleContent.classList.remove('collapsed');
	}
    window.addEventListener('resize', handleResize, true);
}